module.exports = __webpack_public_path__ + "card.png?4f32656b341309616281fcf1e49e2f3b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card.png
// module id = 152
// module chunks = 0